import B5 from "modules/ebiForms/definitions/B5";
import B6 from "modules/ebiForms/definitions/B6";
import D1 from "modules/ebiForms/definitions/D1";
import D2 from "modules/ebiForms/definitions/D2";
import D3 from "modules/ebiForms/definitions/D3";
import E8 from "modules/ebiForms/definitions/E8";
import E9 from "modules/ebiForms/definitions/E9";
import E10 from "modules/ebiForms/definitions/E10";
import { IEbiFormDefinition } from "modules/ebiForms/typings";

/** Drogi gminne i powiatowe: B5, B6, D1, D2, D3, E8, E9, E10 (docs/magistrat/ebi-wnioski). */
const FORMS: IEbiFormDefinition[] = [B5, B6, D1, D2, D3, E8, E9, E10];

export default FORMS;
